import { Injectable } from '@angular/core';
import { CombinedPreset } from '../utilities/presets';
import { PrimeNG } from 'primeng/config';

@Injectable({ providedIn: 'root' })
export class ThemeService {

  constructor(private primeng: PrimeNG) { }


  setLight() {
    document.documentElement.classList.remove('app-dark');
    localStorage.setItem('theme', 'light');
    this.setThemeCookie('light')
  }

  setDark() {
    document.documentElement.classList.add('app-dark');
    localStorage.setItem('theme', 'dark');
    this.setThemeCookie('dark')

  }

  loadSaved() {
    const saved = localStorage.getItem('theme');
    saved === 'dark' ? this.setDark() : this.setLight();
  }

  setThemeCookie(theme: 'light' | 'dark') {
    const expires = new Date();
    expires.setHours(24, 0, 0, 0);
    document.cookie = `theme=${theme}; expires=${expires.toUTCString()}; path=/`;
  }

}
